import { Accounting, IntegrationStatus, PracticeManagement } from '~/types/api.model';
import { EmailOnBehalfTypes } from '../EmailOnBehalfSettingsModel';
export function qboIntegration(integrations) {
    return integrations === null || integrations === void 0 ? void 0 : integrations.find(isQboIntegration);
}
export function accountingIntegration(integrations, accounting) {
    switch(accounting){
        case Accounting.QBO:
            return integrations === null || integrations === void 0 ? void 0 : integrations.find(isQboIntegration);
        case Accounting.Xero:
            return integrations === null || integrations === void 0 ? void 0 : integrations.find(isXeroIntegration);
    }
}
export function xeroIntegration(integrations) {
    return integrations === null || integrations === void 0 ? void 0 : integrations.find(isXeroIntegration);
}
export function isQboIntegration(integration) {
    return integration.source === Accounting.QBO;
}
export function isXeroIntegration(integration) {
    return integration.source === Accounting.Xero;
}
export function financialCentsIntegration(integrations) {
    return integrations === null || integrations === void 0 ? void 0 : integrations.find(isFinancialCentsIntegration);
}
export const karbonIntegration = (integrations)=>integrations === null || integrations === void 0 ? void 0 : integrations.find(isKarbonIntegration);
export const keeperIntegration = (integrations)=>integrations === null || integrations === void 0 ? void 0 : integrations.find(isKeeperIntegration);
export const gmailIntegration = (integrations)=>integrations === null || integrations === void 0 ? void 0 : integrations.find(isGmailIntegration);
export const outlookIntegration = (integrations)=>integrations === null || integrations === void 0 ? void 0 : integrations.find(isOutlookIntegration);
export const karbonDefaultAssignee = (integration)=>isKarbonIntegration(integration) ? integration.karbon.defaultAssigneeId : undefined;
export const clientHubIntegration = (integrations)=>integrations === null || integrations === void 0 ? void 0 : integrations.find(isClientHubIntegration);
export function isFinancialCentsIntegration(integration) {
    return integration.source === PracticeManagement.FinancialCents;
}
export const isKarbonIntegration = (integration)=>integration.source === PracticeManagement.Karbon;
export const isClientHubIntegration = (integration)=>integration.source === PracticeManagement.ClientHub;
export const isKeeperIntegration = (integration)=>integration.source === PracticeManagement.Keeper;
export function isLinked(integration) {
    return integration.status === IntegrationStatus.Linked;
}
export const isGmailIntegration = (integration)=>integration.source === EmailOnBehalfTypes.Gmail;
export const isOutlookIntegration = (integration)=>integration.source === EmailOnBehalfTypes.Outlook;
